import React, { useState } from 'react';
import { Card, CardHead, Pill } from '../components/UI';
import s from './Onboarding.module.css';

const TABS = ['Company details', 'KYC documents', 'Bank & compliance', 'Review & activate'];

const PIPELINE = [
  { name:'Astra Petro Pvt Ltd', invited:'01 Jul', stage:'new', label:'KYC pending' },
  { name:'VRM Chemicals', invited:'28 Jun', stage:'review', label:'Bank verification' },
  { name:'Gulf Lube Exports', invited:'25 Jun', stage:'pending', label:'Contract sent' },
  { name:'Eastern Agro Ltd', invited:'20 Jun', stage:'ready', label:'Activated' },
];

export default function Onboarding() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={s.grid}>
      <Card>
        <CardHead title="Add new supplier" />
        <div className={s.stepBar}>
          {TABS.map((t, i) => (
            <button
              key={i}
              className={`${s.stepTab} ${activeTab === i ? s.stepTabActive : ''}`}
              onClick={() => setActiveTab(i)}
            >
              {t}
            </button>
          ))}
        </div>

        <div className={s.formRow}>
          <div>
            <div className={s.formLabel}>Company name</div>
            <input className={s.inp} placeholder="e.g. Petro Supplies Ltd" />
          </div>
          <div>
            <div className={s.formLabel}>Contact person</div>
            <input className={s.inp} placeholder="Full name" />
          </div>
        </div>
        <div className={s.formRow}>
          <div>
            <div className={s.formLabel}>Email address</div>
            <input className={s.inp} placeholder="accounts@company.com" />
          </div>
          <div>
            <div className={s.formLabel}>Phone number</div>
            <input className={s.inp} placeholder="+91 98xxxxxx" />
          </div>
        </div>
        <div className={s.formRow}>
          <div>
            <div className={s.formLabel}>GSTIN</div>
            <input className={s.inp} placeholder="33AAAAA0000A1Z5" />
          </div>
          <div>
            <div className={s.formLabel}>PAN number</div>
            <input className={s.inp} placeholder="AAAAA0000A" />
          </div>
        </div>
        <div style={{marginBottom:10}}>
          <div className={s.formLabel}>Supplier category</div>
          <select className={s.inp}>
            <option>Select category</option>
            <option>Petroleum products</option>
            <option>Chemicals</option>
            <option>Lubricants</option>
            <option>Engineering services</option>
            <option>IT &amp; infrastructure</option>
          </select>
        </div>
        <button className={s.btnPrimary} style={{width:'100%',justifyContent:'center'}}>
          Send onboarding invitation →
        </button>
      </Card>

      <Card>
        <CardHead title="Onboarding pipeline" />
        <table className={s.table}>
          <thead>
            <tr><th>Supplier</th><th>Invited</th><th>Stage</th></tr>
          </thead>
          <tbody>
            {PIPELINE.map(p => (
              <tr key={p.name}>
                <td>{p.name}</td>
                <td style={{color:'var(--muted)',fontSize:11}}>{p.invited}</td>
                <td><Pill type={p.stage}>{p.label}</Pill></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className={s.autoBox}>
          <div className={s.autoTitle}><i className="ti ti-robot" /> Automated email triggered on invitation</div>
          <div className={s.autoText}>
            Supplier receives secure portal link → completes registration → uploads KYC → digitally accepts contract → admin reviews → activates within 48h.
          </div>
        </div>
      </Card>
    </div>
  );
}
